import { render, staticRenderFns } from "./ParentAuth.vue?vue&type=template&id=05339e1f&scoped=true&"
import script from "./ParentAuth.vue?vue&type=script&lang=js&"
export * from "./ParentAuth.vue?vue&type=script&lang=js&"
import style0 from "./ParentAuth.vue?vue&type=style&index=0&id=05339e1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05339e1f",
  null
  
)

export default component.exports